type EventHandler = (data?: unknown) => void;

class EventBus {
  events: Record<string, EventHandler[]>;
  
    constructor() {
      this.events = {};
    }
  
    on(eventName: string, fn?: EventHandler) {
      this.events[eventName] = this.events[eventName] || [];
      if (fn) {
        this.events[eventName].push(fn);
      }
    }
  
    off(eventName: string, fn?: EventHandler) {
      if (this.events[eventName]) {
        for (let i = 0; i < this.events[eventName].length; i++) {
          if (this.events[eventName][i] === fn) {
            this.events[eventName].splice(i, 1);
            break;
          }
        }
      }
    }
  
    emit(eventName: string, data?: unknown) {
      if (this.events[eventName]) {
        this.events[eventName].forEach(function (fn) {
          fn(data);
        })
      }
    }
  }
  
  export default new EventBus();